export var HEADER_NAVIGATION_MENU_CONTENT_HEADER_CLASS_PREFIX = 'HeaderNavigationMenuContentHeader';
export var headerNavigationMenuContentHeaderRoot = 'HeaderNavigationMenuContentHeaderRoot';